import Card from '../../../../components/card';
import CopyInput from '../../../../components/copyinput';
import Input1 from '../../../../components/input';
import Select1 from '../../../../components/select';
import cr from './style.module.scss';

import SubmitBtn from '../../../../components/submit';

import { Outlet, Link, useLoaderData, Form } from 'react-router-dom';
import UploadFile from '../../../../components/uploadfile';
import Notif from '../../../../components/notif';

import TrsRow from '../../../../components/trs';
import { useActionData, useSubmit } from 'react-router-dom';
import { loaderPostFetch } from '../../util';

import { useState, useEffect } from 'react';

export async function mpcloader({ params }) {
  const formData = new FormData();
  formData.append('getmpcform', 'getmpcform');

  let tok = window.localStorage.getItem('baUid');
  if (tok != null) {
    formData.append('token', tok);
  }
  const res = await loaderPostFetch(`api/users.php`, formData);

  //const sessions = await getfetch(`${apiUrl}/sessionlist`, {});
  return { ...params, ...res };
}

export async function mpcaction({ request, params }) {
  //loader will fetch details
  const formData = await request.formData();

  let tok = window.localStorage.getItem('baUid');
  if (tok != null) {
    formData.append('token', tok);
  }
  const contact = await loaderPostFetch(`api/users.php`, formData);

  return contact;
}

export default function CryptoDeposit() {
  const { names, addresses,addresses2, purposes, transactions, currency } = useLoaderData();
  const [g, sGee] = useState(addresses?.[0]);

  let actionData = useActionData();

  const [n, sN] = useState({ display: false, type: 'success', msg: '' });

  useEffect(() => {
    /*console.log({ actionData });*/
    if (actionData) {
      let s = actionData;
      if (s?.icon) {
        if (s?.icon == 'success') {
          sN({ ...n, display: true, type: 'warning', msg: 'Payment Pending!' });
        } else {
          sN({ ...n, display: true, type: 'error', msg: 'Something went wrong!' });
        }
      }
      setTimeout(() => {
        sN({ ...n, display: false, type: 'success', msg: 'Copied to clipboard' });
      }, 5000);
      /*sN({ display: true, type: 'success', msg: `${s?.message1}` });
          setTimeout(() => {
            sN({ display: false, type: 'success', msg: `` }); 
          }, 5000);*/
    }
  }, [actionData]);

  return (
    <>
      <Notif display={n?.display} type={n?.type} msg={n?.msg} />

      <div className={cr.h2}>Crypto Deposit</div>
      <div className={cr.p2}>Make Payments </div>

      <Form method="post" encType="multipart/form-data">
        <input type="hidden" name="newmpc" value="newmpc" />

        <Card title="About ">
          <div className={cr.h}>Select what you are depositing for</div>
          <Select1 name="purpose">
            {/*
            <option>Tax</option>*/}
            {purposes?.map((w, i) => {
              return (
                <option value={w?.purpose_name} key={i}>
                  {w?.purpose_name}
                </option>
              );
            })}
          </Select1>
        </Card>

        <Card title="Deposit method">
          <div className={cr.h}>
            To deposit, choose the payment method panel and make the payment to the displayed address. After payment has
            been made, come back to fill this form.
          </div>

          <Select1
            label="Type"
            name="type"
            onChange={(e) => {
              sGee(addresses2[e.target.value]);
            }}
          >
            {/*
            <option>Bitcoin</option>*/}
            {names?.map((w, i) => {
              return <option key={i} >{w}</option>;
            })}
          </Select1>
          <CopyInput label="Address:" value={g} 
            proceed={() => {
              sN({ display: true, type: 'success', msg: `Copied to clipboard` });
              setTimeout(() => {
                sN({ display: false, type: 'success', msg: `` });
              }, 5000);
            }} />
          <Input1 name="amount" label="Amount:" />
          <UploadFile label="Payment Proof:" name="depositPic" />

          <SubmitBtn label="Submit Deposit " />
        </Card>
      </Form>

      {transactions ? <p>Crypto Transactions</p> : null}
      {transactions &&
        transactions?.map((n, i) => {
          return (
            <TrsRow
              currency={currency}
              key={i}
              type={n?.type}
              amount={n?.amount}
              status={n?.status}
              date={n?.created_at}
            />
          );
        })}
    </>
  );
}
